var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.debug)?_c('div',[_c('b',{staticClass:"xs-font",on:{"click":function($event){_vm.show = !_vm.show}}},[_c('i',{staticClass:"fa fa-bug"}),_vm._v(" "+_vm._s(_vm.show ? _vm.name : ''))]),(_vm.show)?_c('code',[_vm._v(_vm._s(_vm.entry || _vm.$store.state))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }